/* eslint-disable */
import { callStatic, ChatterCommentsResponse } from 'services/api-service'

/**
 * Comments for chatter
 *
 * @method
 * @name ApiService#chatterComments
 * @param {string} sku - 
 * @param {integer} offset - 
 * @param {integer} limit - 
 * @param {string} sort - Possible values are:
 * 0 (default) - by id, descending
 * 1 - by length of comment text, descending

 * @param {integer} minCharCount - 
 * @param {integer} minWordCount - 
 * @param {boolean} includeSyndicated - 
 * @param {boolean} includeRelated - 
 */
function chatterComments(parameters: {
  sku: string
  offset: number
  limit: number
  sort: 0 | 1
  minCharCount: number
  minWordCount: number
  includeSyndicated: boolean
  includeRelated: boolean
}): Promise<ChatterCommentsResponse> {
  return callStatic<ChatterCommentsResponse>(
    '/sitedata/{siteKey}/chatter/{sku}/{locale}/{offset}/{limit}/{sort}/{minCharCount}/{minWordCount}/{includeSyndicated}/{includeRelated}',
    parameters,
    [
      'sku',
      'offset',
      'limit',
      'sort',
      'minCharCount',
      'minWordCount',
      'includeSyndicated',
      'includeRelated'
    ]
  )
}

export default { chatterComments }
